/**
 * document.title + description/og/twitter tags, kept in sync with the route.
 *
 * Two inputs, one writer:
 *  - the route table (`shared/seo.ts`) — applied on every navigation by `<RouteMeta/>` in
 *    `__root.tsx`;
 *  - a page-level override (`usePageTitle`) for dynamic titles (card names, FAQ articles).
 * React runs the page's effect BEFORE the root's on the same commit, so whichever fires
 * last must compute the same answer: both call `applyPageMeta()`, which reads the
 * override first and falls back to the table.
 */
import { resolveSeo, tabTitle, titlePrefix } from "@shared/seo";

let overrideTitle: string | null = null;

export function setPageTitleOverride(title: string | null) {
  overrideTitle = title;
  applyPageMeta();
}

function setMeta(selector: string, content: string) {
  const el = document.head.querySelector<HTMLMetaElement>(selector);
  if (el) el.setAttribute("content", content);
}

export function applyPageMeta(pathname: string = window.location.pathname) {
  const seo = resolveSeo(pathname);
  const prefix = titlePrefix();
  document.title = overrideTitle != null ? tabTitle(overrideTitle) : `${prefix}${seo.title}`;
  const ogTitle =
    overrideTitle != null ? tabTitle(overrideTitle).slice(prefix.length) : seo.metaTitle;
  setMeta('meta[name="description"]', seo.description);
  setMeta('meta[property="og:title"]', ogTitle);
  setMeta('meta[property="og:description"]', seo.description);
  setMeta('meta[name="twitter:title"]', ogTitle);
  setMeta('meta[name="twitter:description"]', seo.description);
}
